import { Link, useLocation } from "react-router-dom";
import { CategoriesQueriesClient } from "../../requests/queries/CategoriesQueries";
import { useState, useEffect, useCallback } from "react";
import "./Sidebar.css";
import tokens from "../../utils/token";
import { useTheme } from "../../contexts/ThemeContext";

export default function Sidebar() {
    const [categories, setCategories] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();
    const { isDarkMode } = useTheme();
    const [isMobile, setIsMobile] = useState(() => window.innerWidth <= 768);

    useEffect(() => {
        const checkMobile = () => setIsMobile(window.innerWidth <= 768);
        window.addEventListener("resize", checkMobile);
        return () => window.removeEventListener("resize", checkMobile);
    }, []);

    const [currentCategory, setCurrentCategory] = useState(null);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const category = params.get('category');
        if (category) {
            setCurrentCategory(category);
        }
    }, [location]);

    useEffect(() => {
        const fetchCategories = async () => {
            const res = await CategoriesQueriesClient.findAll();
            setCategories(res.data.categories);
        };
        fetchCategories();
    }, []);

    // Fermer le menu quand on change de page
    useEffect(() => {
        setIsOpen(false);
    }, [location]);

    // Gérer le scroll du body
    useEffect(() => {
        if (isOpen) {
            document.body.classList.add('sidebar-open');
        } else {
            document.body.classList.remove('sidebar-open');
        }
        return () => {
            document.body.classList.remove('sidebar-open');
        };
    }, [isOpen]);

    const toggleMenu = useCallback(() => {
        setIsOpen(prev => !prev);
    }, []);

    const closeMenu = useCallback(() => {
        setIsOpen(false);
    }, []);

    const handleLogout = () => {
        tokens.client_token.removeToken();
        window.location.href = '/client-auth';
    };

    return (
        <>
            {/* Bouton Burger */}
            <button 
                className={`sidebar-burger-btn ${isOpen ? 'is-open' : ''}`}
                onClick={toggleMenu}
                aria-label={isOpen ? "Close menu" : "Open menu"}
                aria-expanded={isOpen}
            >
                <span className="burger-icon">
                    <span className="burger-line" style={{ background: '#fff' }}></span>
                    <span className="burger-line" style={{ background: '#fff' }}></span>
                    <span className="burger-line" style={{ background: '#fff' }}></span>
                </span>
            </button>

            {/* Overlay */}
            <div 
                className={`sidebar-overlay ${isOpen ? 'is-visible' : ''}`}
                onClick={closeMenu}
                aria-hidden="true"
            />

            {/* Sidebar */}
            <div className="sidebar-mobile-container">
                <aside className={`patricians-sidebar ${isOpen ? 'is-open' : ''}`}>
                    {
                        isMobile && (
                            <div className="patricians-header-logo" style={{textAlign: 'left'}}>
                                <Link to="/shop" className="patricians-logo-link">
                                <img 
                                    src={isDarkMode ? "/patricians2.png" : "/patricians.png"} 
                                    alt="Logo" 
                                    className="patricians-logo-image"
                                />
                                </Link>
                            </div>
                        )
                    }
                    <nav className="patricians-nav">
                        <Link
                            to="/shop"
                            className="patricians-nav-link"
                            onClick={closeMenu}
                        >
                            ALL
                        </Link>
                        {categories.map(category => {
                            return (<Link
                                key={category.id}
                                to={`/shop?category=${category.id}`}
                                className={`patricians-nav-link ${category.id === currentCategory ? 'active' : ''}`}
                                onClick={closeMenu}
                            >
                                {category.name.toUpperCase()}
                            </Link>)
                        })}
                        <div className="patricians-nav-divider"></div>
                        <Link to="/client/profile" className="patricians-nav-link" onClick={closeMenu}>PROFILE</Link>
                        <Link to="/client/commands" className="patricians-nav-link" onClick={closeMenu}>MY ORDERS</Link>
                        <a 
                            href="https://www.instagram.com/patricians.xyz/#" 
                            target="_blank" 
                            rel="noopener noreferrer" 
                            className="patricians-nav-link patricians-instagram-link"
                        >
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
                                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
                                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
                            </svg>
                            INSTAGRAM
                        </a>
                        <Link to="/shipping-policy" className="patricians-nav-link" onClick={closeMenu}>SHIPPING POLICY</Link>
                        <Link to="/terms" className="patricians-nav-link" onClick={closeMenu}>TERMS OF SERVICE</Link>
                        <Link className="patricians-nav-link" onClick={handleLogout}>
                            Log out
                        </Link>
                    </nav>
                </aside>
            </div>
        </>
    );
}